import Vue from 'vue'
import Snack from './Snack/Snack.vue'
import snackMixin from '@/mixins/snackMixin'
import SnackModel from '@/models-ts/Snack'

export default Vue.extend<any, any, any, any>({
  name: 'lx-snackbar-stack-new',
  mixins: [snackMixin],
  components: {
    Snack,
  },
  methods: {
    onSnackBeforeLeave(el: HTMLDivElement) {
      el.style.width = `${el.clientWidth}px`
      this.$el.style.minWidth = `${el.clientWidth}px`
      el.style.position = 'absolute'
    },
    onSnackAfterLeave() {
      this.$el.style.minWidth = ''
    },
    onCloseSnack(snack: SnackModel) {
      this.deleteSnackbar(snack.id)
    },
  },
})
